var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.show,
            title: "商品选择",
            "close-on-click-modal": false,
            width: "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { inline: "", size: "small" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.search_form.search_type,
                        callback: function($$v) {
                          _vm.$set(_vm.search_form, "search_type", $$v)
                        },
                        expression: "search_form.search_type"
                      }
                    },
                    _vm._l(_vm.options.search_type, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    model: {
                      value: _vm.search_form.search_value,
                      callback: function($$v) {
                        _vm.$set(_vm.search_form, "search_value", $$v)
                      },
                      expression: "search_form.search_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.search_form.page = 1
                          _vm.toSearch()
                        }
                      }
                    },
                    [_vm._v("搜索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "tableRef",
              attrs: {
                data: _vm.rs.list,
                "max-height": "500px",
                "row-key": "goods_no"
              },
              on: { "selection-change": _vm.selectHandle }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  align: "center",
                  "reserve-selection": true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_kh", label: "款号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_name",
                  label: "商品标题",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_img", label: "图片", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticStyle: {
                              width: "40px",
                              height: "40px",
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "inline-block"
                            }
                          },
                          _vm._l(scope.row.middle_img, function(item, key) {
                            return _c("img", {
                              key: key,
                              staticStyle: {
                                "max-width": "100%",
                                "max-height": "100%"
                              },
                              attrs: { src: item }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "plan_price", label: "代采价", align: "center" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "5px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                  "current-page": _vm.search_form.page,
                  "page-size": _vm.search_form.psize,
                  total: _vm.rs.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.search_form, "page", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.search_form, "page", $event)
                  },
                  "current-change": _vm.toSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "left" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择入仓标签" },
                  model: {
                    value: _vm.emit.goods_label,
                    callback: function($$v) {
                      _vm.$set(_vm.emit, "goods_label", $$v)
                    },
                    expression: "emit.goods_label"
                  }
                },
                _vm._l(_vm.goods_label, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "infor" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.submit } },
                [_vm._v("确定 (" + _vm._s(_vm.emit.goods.length) + ")")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc2092ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2092ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlanGoodsSelect.vue
// module id = null
// module chunks = 